import { DateRangeInputForm } from 'modules/order/forms';
import { observable, action, makeObservable } from 'mobx';
import { advancedFilterCondition, dateFilterOptions } from 'common/constants';
import moment from 'moment';
import { localStorageHandler } from 'core/services';
import { initialDateFilterOption } from 'common/constants';
import _ from 'lodash';
import { BaasicDropdownViewStore } from 'common/stores';
import { translate } from 'core/utils';

class OrderDateRangeViewStore {
	@observable customDateRange = false;
	@observable newFilter = true;
	dateFieldName = 'dateCreated';
	queryUtility = null;
	findFunction = {};
	localStorageHandlerKey = null;

	form = new DateRangeInputForm();

	constructor(props) {
		makeObservable(this);
		this.initialize(props);
	}

	@action.bound
	initialize = async ({ queryUtility, findFunction, localStorageHandlerKey }) => {
		Object.assign(this, {
			queryUtility,
			findFunction,
			localStorageHandlerKey,
		});
		this.dateFilterDropdownStore = new BaasicDropdownViewStore();
		await this.dateFilterDropdownStore.initialize({
			staticOptions: dateFilterOptions,
			filterProperties: {
				orderBy: 'id',
			},
			localStorageHandlerKey: localStorageHandlerKey,
			onChangeCallback: async value => await this.onDateSelect(value),
			initCallback: async () =>
				await this.dateFilterDropdownStore.setValue(this.dateFilterDropdownStore.value || initialDateFilterOption),
			onBeforeChangeCallback: async () => {
				this.previousFilterValue = this.dateFilterDropdownStore.value;
			},
		});
	};

	@action.bound
	closeCustomDateRange = async () => {
		this.customDateRange = false;
		this.isCustomDateWindowOpened = true;
		if (this.previousFilterValue.value !== 'custom')
			await this.dateFilterDropdownStore.setValue(this.previousFilterValue || initialDateFilterOption);
		this.isCustomDateWindowOpened = false;
	};

	@action.bound
	onDateSelect = async selectedValue => {
		const selectedDateFilterOption = selectedValue || initialDateFilterOption;
		if (selectedDateFilterOption.value == 'None') {
			return;
		}
		let dateBegin = new Date();
		let dateEnd = Date.now();
		this.customDateRange = false;
		switch (selectedDateFilterOption.value) {
			case 'last30Days':
				dateBegin.setDate(dateBegin.getDate() - 30);
				break;
			case 'last90Days':
				dateBegin.setDate(dateBegin.getDate() - 90);
				break;
			case 'last180Days':
				dateBegin.setDate(dateBegin.getDate() - 180);
				break;
			case 'last365Days':
				dateBegin.setDate(dateBegin.getDate() - 365);
				break;
			case 'custom':
				this.customDateRange = true;
				break;
		}
		if (!this.customDateRange && !this.isCustomDateWindowOpened) {
			this.populateDateFilter(dateBegin, dateEnd);
		} else if (this.newFilter) {
			this.populateDateFilter(...Object.values(localStorageHandler.get('custom-date-range')));
			this.customDateRange = false;
		}
		this.newFilter = false;
	};

	@action.bound
	populateDateFilter = async (dateBegin, dateEnd) => {
		const rangeStartFilterElement = {
			condition: advancedFilterCondition.GreaterEqual,
			fieldName: this.dateFieldName,
			filterValue: [{ value: moment(dateBegin).format('YYYY/MM/DD') }],
		};
		const rangeEndFilterElement = {
			condition: advancedFilterCondition.LesserEqual,
			fieldName: this.dateFieldName,
			filterValue: [{ value: moment(dateEnd).format('YYYY/MM/DD') }],
		};
		_.remove(this.queryUtility.filter.advancedSearch, { fieldName: this.dateFieldName });
		if (!this.queryUtility.filter.advancedSearch) {
			this.queryUtility.filter.advancedSearch = [];
		}
		this.queryUtility.filter.advancedSearch.push(rangeStartFilterElement);
		this.queryUtility.filter.advancedSearch.push(rangeEndFilterElement);
		if (!this.newFilter) await this.findFunction();
	};

	@action.bound
	onDateInput = async () => {
		this.populateDateFilter(this.form.$('dateRangeStart').value, this.form.$('dateRangeEnd').value);
		localStorageHandler.set('custom-date-range', {
			dateRangeStart: this.form.$('dateRangeStart').value,
			dateRangeEnd: this.form.$('dateRangeEnd').value,
		});
		this.customDateRange = false;
	};

	@action.bound
	todayFilterChange = checked => {
		this.resetFilter(checked, false);
	};

	@action.bound
	resetFilter = (hideFilter = true, setToNull = false) => {
		if (setToNull) {
			this.dateFilterDropdownStore.value = {
				value: 'None',
				label: translate('ORDERVIEW.PLACEHOLDER.DATERANGESELECT'),
			};
		}
		hideFilter
			? _.remove(this.queryUtility.filter.advancedSearch, { fieldName: this.dateFieldName })
			: this.dateFilterDropdownStore.value.value != 'custom'
			? this.dateFilterDropdownStore.setValue(
					this.dateFilterDropdownStore.value.value !== 'None'
						? this.dateFilterDropdownStore.value
						: initialDateFilterOption
			  )
			: this.onDateInput();
	};
}

export default OrderDateRangeViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/OrderDateRangeViewStore.js